import { Configuration, SuppliersApi } from '@/api';
import useGetOrganizationQuery from '@/api/queries/useGetOrganizationQuery';
import useGetSupplierQuery from '@/api/queries/useGetSupplierQuery';
import CustomToast from '@/components/CustomToast';
import SpinnerIcon from '@/components/icons/SpinnerIcon';
import PageHeader from '@/components/PageHeader';
import Breadcrumbs from '@/modules/admin/components/Breadcrumbs';
import SupplierToRetailerForm, {
  SupplierToRetailer,
} from '@/modules/admin/components/SupplierToRetailerForm';
import { SupplierToRetailerListPath } from '@/modules/admin/paths';
import { useAuth } from '@/modules/auth/contexts/AuthContext';
import toast from 'react-hot-toast';
import { useNavigate, useParams } from 'react-router-dom';

const SupplierToRetailerAdd = () => {
  const navigate = useNavigate();

  const { supplierId } = useParams<{ supplierId: string }>();

  const suppliersApi = new SuppliersApi(new Configuration(useAuth));

  const { isLoading: isLoadingSupplier, supplier } = useGetSupplierQuery(supplierId);

  const { isLoading: isLoadingOrganization, organization } = useGetOrganizationQuery(
    supplier?.organizationId,
  );

  if (isLoadingSupplier || isLoadingOrganization) {
    return (
      <div className="flex justify-center py-20">
        <SpinnerIcon />
      </div>
    );
  }

  if (!supplier) {
    return null;
  }

  const handleOnSubmit = async (data: SupplierToRetailer): Promise<void> => {
    if (!supplierId || !data.retailer) return;

    await suppliersApi.addRetailersToSupplier(supplierId, [
      {
        id: data.retailer.id,
        customerCode: data.customerCode,
      },
    ]);

    toast.custom((t) => (
      <CustomToast id={t.id} message="Retailer added successfully!" visible={t.visible} />
    ));

    navigate(SupplierToRetailerListPath.withSupplierId(supplierId));
  };

  return (
    <>
      <Breadcrumbs />

      <PageHeader title="Link Retailer" />

      <div className="w-full bg-white mx-auto rounded-lg shadow p-6 lg:p-12">
        <SupplierToRetailerForm
          supplier={supplier}
          organization={organization}
          onSubmit={handleOnSubmit}
        />
      </div>
    </>
  );
};

export default SupplierToRetailerAdd;
